/**
 * @generated SignedSource<<88a6e3e5bd5b9b42e6701da9bb6ce108>>
 * @relayHash edd863f14a15d733e302fb5f4b7e2308
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8c3ecce0aec8f270bf98e0d88b202a9a261475df10e29bc6bd1b1e0634b05ed5

import type { ConcreteRequest, Query } from 'relay-runtime';
export type CcpEntitlementPreDunningStatus = "IN_PRE_DUNNING" | "NOT_IN_PRE_DUNNING" | "%future added value";
export type GrowthUnifiedProfileTrialTrigger = "AUTO_UPGRADE_USER_LIMIT" | "CROSSFLOW_USER_LIMIT" | "EDITION_PARITY" | "EDITION_PARITY_AUTO_PROVISIONING" | "REACTIVATION" | "REVERSE_TRIAL" | "UI" | "%future added value";
export type GrowthUnifiedProfileTrialType = "AUTO_UPGRADE" | "DIRECT_TRIAL" | "MANUAL_TRIAL" | "REVERSE_TRIAL" | "%future added value";
export type JiraApplicationKey = "JIRA_CORE" | "JIRA_PRODUCT_DISCOVERY" | "JIRA_SERVICE_DESK" | "JIRA_SOFTWARE" | "%future added value";
export type CommerceEntitlementFilter = {
  AND?: ReadonlyArray<CommerceEntitlementFilter | null | undefined> | null | undefined;
  OR?: ReadonlyArray<CommerceEntitlementFilter | null | undefined> | null | undefined;
  hasRelationshipFromWithType?: string | null | undefined;
  inPreDunning?: boolean | null | undefined;
  inTrialOrPreDunning?: boolean | null | undefined;
};
export type editionAwarenessQuery$variables = {
  accountId: string;
  applicationKey: JiraApplicationKey;
  chargeElement: string;
  cloudId: string;
  entitlementFilter?: CommerceEntitlementFilter | null | undefined;
  onboardingStateKeys: ReadonlyArray<string>;
  productKey: string;
  shouldCheckForAddPaymentDetails: boolean;
  shouldCheckForChargeQuantities: boolean;
  shouldCheckForDirectBuyChangeOffering: boolean;
  shouldCheckForPaymentDetails: boolean;
  shouldCheckForStorageLimit: boolean;
  shouldCheckForStorageUsageJira: boolean;
  shouldCheckForTrial: boolean;
  shouldCheckForUserEmail: boolean;
  shouldCheckUserPreferences: boolean;
  shouldSkip: boolean;
};
export type editionAwarenessQuery$data = {
  readonly jira?: {
    readonly attachmentStorageAllowed?: AGG$Long | null | undefined;
    readonly attachmentStorageIsUnlimited?: boolean | null | undefined;
    readonly attachmentStorageUsed: AGG$Long | null | undefined;
  } | null | undefined;
  readonly tenantContexts?: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement?: {
        readonly entitlementProfile: {
          readonly lastKnownTrial: {
            readonly createdAt: number | null | undefined;
            readonly offeringId: string | null | undefined;
            readonly trialEndTimeStamp: number | null | undefined;
            readonly trialTrigger: GrowthUnifiedProfileTrialTrigger | null | undefined;
            readonly trialType: GrowthUnifiedProfileTrialType | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly experienceCapabilities: {
          readonly changeOfferingV2: {
            readonly experienceUrl: string | null | undefined;
            readonly isAvailableToUser: boolean | null | undefined;
          } | null | undefined;
          readonly changeOfferingV2WithSkipTrial?: {
            readonly experienceUrl: string | null | undefined;
            readonly isAvailableToUser: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly latestUsageForChargeElement?: number | null | undefined;
        readonly offering?: {
          readonly key: string | null | undefined;
          readonly trial: {
            readonly lengthDays: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly preDunning?: {
          readonly status: CcpEntitlementPreDunningStatus | null | undefined;
        } | null | undefined;
        readonly relatesFromEntitlements: ReadonlyArray<{
          readonly entitlementId: string | null | undefined;
          readonly relationshipType: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly relatesFromEntitlementsWithCollectionType: ReadonlyArray<{
          readonly entitlement: {
            readonly preDunning: {
              readonly status: CcpEntitlementPreDunningStatus | null | undefined;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly subscription?: {
          readonly accountDetails: {
            readonly invoiceGroup: {
              readonly experienceCapabilities: {
                readonly configurePaymentV2: {
                  readonly experienceUrl: string | null | undefined;
                  readonly isAvailableToUser: boolean | null | undefined;
                } | null | undefined;
              } | null | undefined;
              readonly invoiceable: boolean | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly trial: {
            readonly endTimestamp: number | null | undefined;
            readonly startTimestamp: number | null | undefined;
            readonly timeLeft: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly transactionAccount: {
          readonly experienceCapabilities?: {
            readonly addPaymentMethodV2: {
              readonly experienceUrl: string | null | undefined;
              readonly isAvailableToUser: boolean | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly isBillToPresent?: boolean | null | undefined;
          readonly isCurrentUserBillingAdmin: boolean | null | undefined;
          readonly key: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly entitlementId: string;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly user?: {
    readonly email?: string | null | undefined;
  } | null | undefined;
  readonly userPreferences?: {
    readonly onboardingState: ReadonlyArray<{
      readonly key: string;
      readonly value: string | null | undefined;
    }>;
  } | null | undefined;
};
export type editionAwarenessQuery = {
  response: editionAwarenessQuery$data;
  variables: editionAwarenessQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "applicationKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "chargeElement"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entitlementFilter"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "onboardingStateKeys"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productKey"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForAddPaymentDetails"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForChargeQuantities"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForDirectBuyChangeOffering"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForPaymentDetails"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForStorageLimit"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForStorageUsageJira"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForTrial"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForUserEmail"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckUserPreferences"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldSkip"
},
v17 = [
  {
    "kind": "Variable",
    "name": "applicationKey",
    "variableName": "applicationKey"
  },
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v18 = {
  "condition": "shouldCheckForStorageUsageJira",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "condition": "shouldCheckForStorageLimit",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": (v17/*: any*/),
              "kind": "ScalarField",
              "name": "attachmentStorageAllowed"
            },
            {
              "args": (v17/*: any*/),
              "kind": "ScalarField",
              "name": "attachmentStorageIsUnlimited"
            }
          ]
        },
        {
          "args": (v17/*: any*/),
          "kind": "ScalarField",
          "name": "attachmentStorageUsed"
        }
      ]
    }
  ]
},
v19 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v20 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "productKey"
  }
],
v21 = {
  "kind": "ScalarField",
  "name": "entitlementId"
},
v22 = [
  {
    "kind": "Variable",
    "name": "where",
    "variableName": "entitlementFilter"
  }
],
v23 = {
  "kind": "ScalarField",
  "name": "id"
},
v24 = {
  "kind": "Literal",
  "name": "offeringName",
  "value": "Standard"
},
v25 = {
  "kind": "ScalarField",
  "name": "isAvailableToUser"
},
v26 = {
  "kind": "ScalarField",
  "name": "experienceUrl"
},
v27 = [
  (v25/*: any*/),
  (v26/*: any*/)
],
v28 = {
  "concreteType": "CcpEntitlementExperienceCapabilities",
  "kind": "LinkedField",
  "name": "experienceCapabilities",
  "plural": false,
  "selections": [
    {
      "args": [
        (v24/*: any*/)
      ],
      "concreteType": "CcpChangeOfferingExperienceCapability",
      "kind": "LinkedField",
      "name": "changeOfferingV2",
      "plural": false,
      "selections": (v27/*: any*/),
      "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
    },
    {
      "condition": "shouldCheckForDirectBuyChangeOffering",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "changeOfferingV2WithSkipTrial",
          "args": [
            (v24/*: any*/),
            {
              "kind": "Literal",
              "name": "skipTrial",
              "value": true
            }
          ],
          "concreteType": "CcpChangeOfferingExperienceCapability",
          "kind": "LinkedField",
          "name": "changeOfferingV2",
          "plural": false,
          "selections": (v27/*: any*/),
          "storageKey": "changeOfferingV2(offeringName:\"Standard\",skipTrial:true)"
        }
      ]
    }
  ]
},
v29 = {
  "condition": "shouldCheckForChargeQuantities",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "chargeElement",
          "variableName": "chargeElement"
        }
      ],
      "kind": "ScalarField",
      "name": "latestUsageForChargeElement"
    }
  ]
},
v30 = {
  "concreteType": "CcpEntitlementPreDunning",
  "kind": "LinkedField",
  "name": "preDunning",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "status"
    }
  ]
},
v31 = {
  "concreteType": "CcpTrial",
  "kind": "LinkedField",
  "name": "trial",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "timeLeft"
    },
    {
      "kind": "ScalarField",
      "name": "startTimestamp"
    },
    {
      "kind": "ScalarField",
      "name": "endTimestamp"
    }
  ]
},
v32 = {
  "kind": "ScalarField",
  "name": "invoiceable"
},
v33 = {
  "concreteType": "CcpInvoiceGroupExperienceCapabilities",
  "kind": "LinkedField",
  "name": "experienceCapabilities",
  "plural": false,
  "selections": [
    {
      "concreteType": "CcpConfigurePaymentMethodExperienceCapability",
      "kind": "LinkedField",
      "name": "configurePaymentV2",
      "plural": false,
      "selections": [
        (v26/*: any*/),
        (v25/*: any*/)
      ]
    }
  ]
},
v34 = {
  "concreteType": "CcpOfferingTrial",
  "kind": "LinkedField",
  "name": "trial",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "lengthDays"
    }
  ]
},
v35 = {
  "kind": "ScalarField",
  "name": "key"
},
v36 = {
  "kind": "ScalarField",
  "name": "isCurrentUserBillingAdmin"
},
v37 = {
  "condition": "shouldCheckForPaymentDetails",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "CcpTransactionAccount",
      "kind": "LinkedField",
      "name": "transactionAccount",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isBillToPresent"
        }
      ]
    }
  ]
},
v38 = {
  "condition": "shouldCheckForAddPaymentDetails",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "CcpTransactionAccount",
      "kind": "LinkedField",
      "name": "transactionAccount",
      "plural": false,
      "selections": [
        {
          "concreteType": "CcpTransactionAccountExperienceCapabilities",
          "kind": "LinkedField",
          "name": "experienceCapabilities",
          "plural": false,
          "selections": [
            {
              "concreteType": "CcpAddPaymentMethodExperienceCapability",
              "kind": "LinkedField",
              "name": "addPaymentMethodV2",
              "plural": false,
              "selections": (v27/*: any*/)
            }
          ]
        }
      ]
    }
  ]
},
v39 = {
  "concreteType": "CcpEntitlementRelationship",
  "kind": "LinkedField",
  "name": "relatesFromEntitlements",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "relationshipType"
    },
    (v21/*: any*/)
  ]
},
v40 = [
  {
    "kind": "Literal",
    "name": "relationshipTypes",
    "value": "COLLECTION"
  }
],
v41 = {
  "concreteType": "GrowthUnifiedProfileEntitlementProfileResult",
  "kind": "LinkedField",
  "name": "entitlementProfile",
  "plural": false,
  "selections": [
    {
      "concreteType": "GrowthUnifiedProfileEntitlementContextTrialResult",
      "kind": "LinkedField",
      "name": "lastKnownTrial",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "trialType"
        },
        {
          "kind": "ScalarField",
          "name": "trialTrigger"
        },
        {
          "kind": "ScalarField",
          "name": "trialEndTimeStamp"
        },
        {
          "kind": "ScalarField",
          "name": "createdAt"
        },
        {
          "kind": "ScalarField",
          "name": "offeringId"
        }
      ]
    }
  ]
},
v42 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  }
],
v43 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "email"
    }
  ],
  "type": "AtlassianAccountUser"
},
v44 = {
  "condition": "shouldCheckUserPreferences",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "UserPreferences",
      "kind": "LinkedField",
      "name": "userPreferences",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "key",
              "variableName": "onboardingStateKeys"
            }
          ],
          "concreteType": "UserOnboardingState",
          "kind": "LinkedField",
          "name": "onboardingState",
          "plural": true,
          "selections": [
            (v35/*: any*/),
            {
              "kind": "ScalarField",
              "name": "value"
            }
          ]
        }
      ]
    }
  ]
},
v45 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/)
    ],
    "kind": "Fragment",
    "name": "editionAwarenessQuery",
    "selections": [
      (v18/*: any*/),
      {
        "condition": "shouldSkip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v19/*: any*/),
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "args": (v20/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": (v22/*: any*/),
                        "concreteType": "CcpEntitlement",
                        "kind": "LinkedField",
                        "name": "entitlement",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/),
                          {
                            "condition": "shouldCheckForTrial",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v30/*: any*/),
                              {
                                "concreteType": "CcpSubscription",
                                "kind": "LinkedField",
                                "name": "subscription",
                                "plural": false,
                                "selections": [
                                  (v31/*: any*/),
                                  {
                                    "concreteType": "CcpAccountDetails",
                                    "kind": "LinkedField",
                                    "name": "accountDetails",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "CcpInvoiceGroup",
                                        "kind": "LinkedField",
                                        "name": "invoiceGroup",
                                        "plural": false,
                                        "selections": [
                                          (v32/*: any*/),
                                          (v33/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "concreteType": "CcpOffering",
                                "kind": "LinkedField",
                                "name": "offering",
                                "plural": false,
                                "selections": [
                                  (v34/*: any*/),
                                  (v35/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "CcpTransactionAccount",
                            "kind": "LinkedField",
                            "name": "transactionAccount",
                            "plural": false,
                            "selections": [
                              (v35/*: any*/),
                              (v36/*: any*/)
                            ]
                          },
                          (v37/*: any*/),
                          (v38/*: any*/),
                          (v39/*: any*/),
                          {
                            "alias": "relatesFromEntitlementsWithCollectionType",
                            "args": (v40/*: any*/),
                            "concreteType": "CcpEntitlementRelationship",
                            "kind": "LinkedField",
                            "name": "relatesFromEntitlements",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "CcpEntitlement",
                                "kind": "LinkedField",
                                "name": "entitlement",
                                "plural": false,
                                "selections": [
                                  (v30/*: any*/)
                                ]
                              }
                            ],
                            "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                          },
                          (v41/*: any*/)
                        ]
                      }
                    ],
                    "type": "CommerceEntitlementInfoCcp"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldCheckForUserEmail",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v42/*: any*/),
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v43/*: any*/)
            ]
          }
        ]
      },
      (v44/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v6/*: any*/),
      (v9/*: any*/),
      (v13/*: any*/),
      (v16/*: any*/),
      (v8/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v12/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v14/*: any*/),
      (v11/*: any*/),
      (v10/*: any*/),
      (v15/*: any*/),
      (v5/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "editionAwarenessQuery",
    "selections": [
      (v18/*: any*/),
      {
        "condition": "shouldSkip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v19/*: any*/),
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "args": (v20/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": [
                  (v45/*: any*/),
                  (v21/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": (v22/*: any*/),
                        "concreteType": "CcpEntitlement",
                        "kind": "LinkedField",
                        "name": "entitlement",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/),
                          (v28/*: any*/),
                          {
                            "concreteType": "CcpTransactionAccount",
                            "kind": "LinkedField",
                            "name": "transactionAccount",
                            "plural": false,
                            "selections": [
                              (v35/*: any*/),
                              (v36/*: any*/),
                              (v23/*: any*/)
                            ]
                          },
                          (v39/*: any*/),
                          {
                            "alias": "relatesFromEntitlementsWithCollectionType",
                            "args": (v40/*: any*/),
                            "concreteType": "CcpEntitlementRelationship",
                            "kind": "LinkedField",
                            "name": "relatesFromEntitlements",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "CcpEntitlement",
                                "kind": "LinkedField",
                                "name": "entitlement",
                                "plural": false,
                                "selections": [
                                  (v30/*: any*/),
                                  (v23/*: any*/)
                                ]
                              }
                            ],
                            "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                          },
                          (v41/*: any*/),
                          (v29/*: any*/),
                          {
                            "condition": "shouldCheckForTrial",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v30/*: any*/),
                              {
                                "concreteType": "CcpSubscription",
                                "kind": "LinkedField",
                                "name": "subscription",
                                "plural": false,
                                "selections": [
                                  (v31/*: any*/),
                                  {
                                    "concreteType": "CcpAccountDetails",
                                    "kind": "LinkedField",
                                    "name": "accountDetails",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "CcpInvoiceGroup",
                                        "kind": "LinkedField",
                                        "name": "invoiceGroup",
                                        "plural": false,
                                        "selections": [
                                          (v32/*: any*/),
                                          (v33/*: any*/),
                                          (v23/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  (v23/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "CcpOffering",
                                "kind": "LinkedField",
                                "name": "offering",
                                "plural": false,
                                "selections": [
                                  (v34/*: any*/),
                                  (v35/*: any*/),
                                  (v23/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v37/*: any*/),
                          (v38/*: any*/)
                        ]
                      }
                    ],
                    "type": "CommerceEntitlementInfoCcp"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldCheckForUserEmail",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v42/*: any*/),
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v45/*: any*/),
              (v43/*: any*/),
              (v23/*: any*/)
            ]
          }
        ]
      },
      (v44/*: any*/)
    ]
  },
  "params": {
    "id": "8c3ecce0aec8f270bf98e0d88b202a9a261475df10e29bc6bd1b1e0634b05ed5",
    "metadata": {},
    "name": "editionAwarenessQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fb1691b41e33c680ea18494afac09d0e";

export default node;
